import {
  ActivityDTO,
  ActivityStatus,
  ApiListRequest,
  ApiListResponse,
} from "@gymflow/types";
import { infiniteQueryOptions, QueryKey } from "@tanstack/react-query";

import { api } from "../../api";
import { numberPagination } from "../../numberPagination";

const keys = {
  all: () => ["staffApiActivity"] as QueryKey,
  list: (filters: unknown) => [...keys.all(), "list", filters] as QueryKey,
};

export const staffApiActivity = {
  keys,
  queries: {},
  infiniteQueries: {
    list: (
      params?: {
        name?: string;
        status?: ActivityStatus;
        sort?: keyof ActivityDTO;
      } & Omit<ApiListRequest, "page">,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.list(params),
        queryFn: async ({ pageParam }) =>
          (
            await api.get<ApiListResponse<ActivityDTO>>("/activity", {
              params: {
                sort: "name",
                status: "ACTIVE",
                ...params,
                page: pageParam,
              },
            })
          ).data,
        ...numberPagination,
      }),
  },
  mutations: {},
};
